import { format } from 'date-fns/esm';

/**
 * Returns date-fns format
 * Accepted formats : https://date-fns.org/v2.0.0-alpha.16/docs/format
 *
 * @param date
 * @param dateFormat
 * @returns {string | *}
 */
export function dateFnsFormat(date, dateFormat) {
  return format(date, dateFormat);
}
